import React from "react";

import { Button } from "semantic-ui-react";

import SettingOAAccountFormDetailed from "Main/SettingOAAccountFormDetailed";

import HeaderCustom from "./HeaderCustom";
import RegisterCompleteContentBasic from "./RegisterCompleteContentBasic";

type RegisterCompleteProps = {
  data: any;
  layout?: "basic" | "detailed";
  onSuccess: () => void;
};

const RegisterComplete: React.FC<RegisterCompleteProps> = (props) => {
  const handleSuccess = () => {
    props.onSuccess();
  };

  return (
    <>
      <div style={{ marginBottom: "40px", textAlign: "center" }}>
        <HeaderCustom as="h2" label="สร้าง Official Account แล้ว" hideDivider />
      </div>

      {props.layout === "detailed" ? (
        <SettingOAAccountFormDetailed data={props.data} readOnly />
      ) : (
        <RegisterCompleteContentBasic data={props.data} />
      )}

      <div style={{ display: "flex", justifyContent: "center", marginTop: "60px" }}>
        <Button className="primary" onClick={handleSuccess}>
          เสร็จสิ้น
        </Button>
      </div>
    </>
  );
};

export default RegisterComplete;
